import { Button } from '@/components/ui/shadcn/button';
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@/components/ui/shadcn/dropdown-menu';
import { useTranslations } from '@/hooks/useTranslations';
import { Columns3 } from 'lucide-react';
import { useState } from 'react';

interface ColumnVisibilityMenuProps {
    allColumns: Array<{ id: string; label: string }>;
    visibleColumns: Set<string>;
    onColumnShow: (columnId: string) => void;
    onColumnHide: (columnId: string) => void;
}

export function ColumnVisibilityMenu({ allColumns, visibleColumns, onColumnShow, onColumnHide }: ColumnVisibilityMenuProps) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslations();

    return (
        <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="outline"
                    size="icon-sm"
                    className="border-border bg-background text-foreground h-9 w-9 rounded-md"
                    aria-label={t('common.tables.view', 'View')}
                    title={t('common.tables.view', 'View')}
                >
                    <Columns3 className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[200px]">
                <DropdownMenuLabel>{t('common.tables.toggle_columns', 'Toggle columns')}</DropdownMenuLabel>
                <DropdownMenuSeparator />
                {/* All columns with checkboxes */}
                {allColumns.map((column) => {
                    const isVisible = visibleColumns.has(column.id);
                    return (
                        <DropdownMenuCheckboxItem
                            key={column.id}
                            checked={isVisible}
                            onCheckedChange={(checked) => {
                                if (checked) {
                                    onColumnShow(column.id);
                                } else {
                                    onColumnHide(column.id);
                                }
                            }}
                            className="cursor-pointer"
                        >
                            {column.label}
                        </DropdownMenuCheckboxItem>
                    );
                })}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
